<p>
  shipping-settings works!
</p>
